export class Alert {
	type: AlertType;
	message: string;
	msgParams: any;
	keep: boolean;
	nom: string;
	clear: boolean;
	onClickFunction: Function;
	functionArguments: any[];
	onClickFunctionBouton2: Function;
	functionArgumentsBouton2: any[];
}

export enum AlertType {
	Success,
	Error,
	Info,
	Warning
}
